import { render, staticRenderFns } from "./jiaotong.vue?vue&type=template&id=957a546e&scoped=true&"
import script from "./jiaotong.vue?vue&type=script&lang=js&"
export * from "./jiaotong.vue?vue&type=script&lang=js&"
import style0 from "./jiaotong.vue?vue&type=style&index=0&id=957a546e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957a546e",
  null
  
)

export default component.exports